(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.kafMobileSearch = {
    attach: function (context, settings) {
      const $searchBlock = $('.search__bar', context),
            $searchToggle = $('.search__show, .search__hide', context),
            $menuTrigger = $('.menu__trigger', context),
            $header = $('.header__wrap', context),
            $mNav = $('#block-kafsubmenu', context);

      if (!$searchBlock.length || !$searchToggle.length) {
        return;
      }

      $('.search__bar').on('focus', '#ais-autocomplete-selectized', function() {
        // If the input is tabbed to while offscreen,
        // transfer focus to the visible magnifying glass
        // and put tabindex="-1" on input. This is a hack.
        if (($(this).offset().left > window.innerWidth) && !($searchBlock.hasClass('search--active'))) {
          $('.search__show').focus();
          $('#ais-autocomplete-selectized').attr('tabindex', '-1');
        }
      });

      // Keyboard support for search trigger: return and space.
      $('.search__show').on('keydown', function(e) {
        if ((e.keyCode == 13) || (e.keyCode == 32)) {
          $(this).click();
        }
      });

      $searchToggle.click(function() {
        $searchBlock.toggleClass('search--active');
        $header.toggleClass('js-active-search');

        if ($searchBlock.hasClass('search--active')) {
          $('#ais-autocomplete-selectized').attr('tabindex', '0');
          window.setTimeout(function() {
            $('#ais-autocomplete-selectized').focus();
          }, 1);
        }
        else {
          $('.search .selectize-dropdown-content').html('');
          $('#ais-autocomplete-selectized').attr('tabindex', '-1');
          window.setTimeout(function() {
            $('.search__show').focus();
          }, 1);
        }

        // If the mobile nav is open, close it. The partial opacity makes things
        // super weird if both are open at once.
        if ($menuTrigger.hasClass('is-open')) {
          $menuTrigger.removeClass('is-open');
          $menuTrigger.attr('aria-expanded', 'false');
          $mNav.removeClass('is-expanded');
          $('.mnav-wrapper', context).removeClass('is-slid slid-parent');
          $('.frontpage', context).removeClass('js-active-mnav');
        }
      });
    },
  };
})(jQuery, Drupal);
